import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Advertising} from '../../../../../../domain/advertising/model/advertising';

@Component({
  selector: 'app-delete-event-dialog',
  templateUrl: './delete-advertising-dialog.component.html'
})
export class DeleteAdvertisingDialogComponent implements OnInit {

  @Output() deleteEvent: EventEmitter<Advertising> = new EventEmitter<Advertising>();

  advertising: Advertising;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public formDialogRef: MatDialogRef<DeleteAdvertisingDialogComponent>) {
    this.advertising = data.advertising;
  }

  ngOnInit(): void {
    this.advertising = this.data.advertising;
  }

  public delete(): void {
    this.deleteEvent.emit(this.advertising);
    this.formDialogRef.close();
  }

  public close(): void {
    this.formDialogRef.close();
  }

}
